import axios from "axios";

// let baseUrl = "https://flexi-comms-api.simplesoft.nz/";
let baseUrl = "https://cma6ldcbik.execute-api.ap-southeast-2.amazonaws.com/default";
let host = window.location.host;
if (
  host == "localhost:8080" ||
  host == "localhost:8081" ||
  host == "localhost:8082" ||
  host == "192.168.178.21:8080" ||
  host == "192.168.178.21:8081" ||
  host == "192.168.178.21:8082" ||
  host == "10.0.0.9:8080"
) {
  baseUrl =
    "https://cma6ldcbik.execute-api.ap-southeast-2.amazonaws.com/default/";
} else if (host.substring(0, 4) == "dev.") {
  baseUrl =
    "https://cma6ldcbik.execute-api.ap-southeast-2.amazonaws.com/default/";
}

let api = axios.create({
  baseURL: baseUrl,
  withCredentials: false
});

export default api;
